"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const createJourneyComponent_1 = require("../../lib/createJourneyComponent");
const Box = createJourneyComponent_1.createJourneyComponent('j-box', 'div');
exports.default = Box;
